module.exports = __webpack_public_path__ + "static/media/ic-checkmark.ca0ac27d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-checkmark.svg
// module id = 611
// module chunks = 14